import { render, staticRenderFns } from "./SimpleCollectionHost.vue?vue&type=template&id=3c656926"
import script from "./SimpleCollectionHost.vue?vue&type=script&lang=js"
export * from "./SimpleCollectionHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports